import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "block text-sm font-medium text-slate-700 mb-1"
};
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-slate-900 truncate flex-1"
};
const _hoisted_3 = {
  key: 1,
  class: "text-sm text-slate-400 flex-1"
};
const _hoisted_4 = {
  class: "flex h-full"
};
const _hoisted_5 = {
  class: "category-sidebar w-[180px] flex-shrink-0 border-r border-slate-200 bg-slate-50 flex flex-col"
};
const _hoisted_6 = {
  class: "flex-1 overflow-y-auto"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "flex items-center gap-2"
};
const _hoisted_9 = {
  class: "w-4 h-4 flex items-center justify-center"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_12 = ["d"];
const _hoisted_13 = {
  class: "truncate"
};
const _hoisted_14 = {
  class: "product-area flex-1 flex flex-col min-w-0"
};
const _hoisted_15 = {
  class: "px-4 py-3 border-b border-slate-200 flex items-center gap-2 min-h-[60px]"
};
const _hoisted_16 = {
  class: "relative flex-1 min-w-0"
};
const _hoisted_17 = {
  class: "flex-1 overflow-y-auto"
};
const _hoisted_18 = {
  key: 0,
  class: "flex items-center justify-center py-12"
};
const _hoisted_19 = {
  key: 1,
  class: "px-4 py-8 text-center"
};
const _hoisted_20 = {
  class: "text-sm text-slate-500 mb-3"
};
const _hoisted_21 = {
  key: 2,
  class: "divide-y divide-slate-100"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  class: "flex items-center justify-between"
};
const _hoisted_24 = {
  class: "flex-1 min-w-0"
};
const _hoisted_25 = {
  class: "text-sm font-medium text-slate-900 truncate"
};
const _hoisted_26 = {
  class: "text-xs text-slate-500 mt-0.5"
};
const _hoisted_27 = {
  key: 0,
  class: "w-5 h-5 text-primary-600 flex-shrink-0 ml-2",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_28 = {
  key: 0,
  class: "px-4 py-2 border-t border-slate-200 bg-slate-50 text-xs text-slate-500"
};
const _hoisted_29 = {
  class: "font-medium text-slate-700"
};
import { ref, computed, watch, onBeforeUnmount } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getProductPage, createTemporaryProduct } from '@/api/product';
export default {
  __name: 'ProductPicker',
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    categories: {
      type: Array,
      default: () => []
    },
    initialProduct: {
      type: Object,
      default: null
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
    allowCreate: {
      type: Boolean,
      default: true
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const triggerRef = ref(null);
    const open = ref(false);
    const loading = ref(false);
    const searchKeyword = ref('');
    const selectedCategoryId = ref(null);
    const products = ref([]);
    let searchTimer = null;
    const selectedProduct = computed(() => {
      if (!props.modelValue) return null;
      return products.value.find(p => p.id === props.modelValue) || (props.initialProduct?.id === props.modelValue ? props.initialProduct : null);
    });
    const displayText = computed(() => {
      const p = selectedProduct.value;
      if (!p) return '';
      return p.code ? `${p.name} (${p.code})` : p.name;
    });
    const panelStyle = computed(() => {
      if (!triggerRef.value || !open.value) return {};
      const rect = triggerRef.value.getBoundingClientRect();
      const panelWidth = 620;
      const panelHeight = 400;
      const gap = 4;
      let top = rect.bottom + gap;
      let left = rect.left;

      // Flip if not enough space below
      if (top + panelHeight > window.innerHeight - 16) {
        top = rect.top - panelHeight - gap;
      }

      // Adjust horizontal to stay in viewport
      if (left + panelWidth > window.innerWidth - 16) {
        left = window.innerWidth - panelWidth - 16;
      }
      if (left < 16) left = 16;
      return {
        top: `${top}px`,
        left: `${left}px`,
        width: `${panelWidth}px`,
        height: `${panelHeight}px`
      };
    });
    const toggle = () => {
      open.value = !open.value;
      if (open.value) {
        searchKeyword.value = '';
        selectedCategoryId.value = null;
        loadProducts();
      }
    };
    const close = () => {
      open.value = false;
    };
    const selectCategory = categoryId => {
      selectedCategoryId.value = categoryId;
      loadProducts();
    };
    const selectProduct = product => {
      emit('update:modelValue', product.id);
      emit('change', product);
      open.value = false;
    };
    const clearSelection = () => {
      emit('update:modelValue', '');
      emit('change', null);
    };
    const loadProducts = async () => {
      loading.value = true;
      try {
        // Search across all categories when keyword is present
        const hasKeyword = searchKeyword.value && searchKeyword.value.trim();
        const data = await getProductPage({
          categoryId: hasKeyword ? undefined : selectedCategoryId.value || undefined,
          keyword: hasKeyword || undefined,
          page: 1,
          size: 100
        });
        products.value = data.records || [];
      } catch (error) {
        console.error('加载产品列表失败', error);
        products.value = [];
      } finally {
        loading.value = false;
      }
    };
    const onSearchInput = () => {
      // Switch to "all products" when searching
      if (searchKeyword.value && searchKeyword.value.trim()) {
        selectedCategoryId.value = null;
      }
      if (searchTimer) clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        loadProducts();
      }, 300);
    };
    const handleAddTempProduct = async () => {
      if (!searchKeyword.value) {
        ElMessage.warning('请输入产品名称');
        return;
      }
      try {
        await ElMessageBox.confirm(`确认创建临时产品「${searchKeyword.value}」？`, '创建产品', {
          confirmButtonText: '确认创建',
          cancelButtonText: '取消',
          type: 'info'
        });
        const newProduct = await createTemporaryProduct({
          name: searchKeyword.value
        });
        ElMessage.success('产品创建成功');
        products.value.unshift({
          id: newProduct.id,
          name: newProduct.name,
          code: newProduct.code
        });
        emit('update:modelValue', newProduct.id);
        emit('change', {
          id: newProduct.id,
          name: newProduct.name,
          code: newProduct.code
        });
        searchKeyword.value = '';
        open.value = false;
      } catch (error) {
        if (error === 'cancel' || error === 'close') return;
        console.error('创建产品失败', error);
        ElMessage.error('创建产品失败');
      }
    };
    const isSvgPath = icon => {
      if (!icon) return false;
      return /^[MLHVCSQTAZmlhvcsqtaz\d\s.,-]+$/.test(icon.trim());
    };
    const resolveFileUrl = fileKey => {
      if (!fileKey) return '';
      if (/^https?:\/\//i.test(fileKey)) return fileKey;
      return `${process.env.VUE_APP_API_BASE_URL || ''}/${fileKey}`.replace(/\/+/g, '/').replace(':/', '://');
    };
    watch(() => props.modelValue, newVal => {
      // If modelValue was cleared externally, reset
      if (!newVal) {
        searchKeyword.value = '';
      }
    });
    onBeforeUnmount(() => {
      if (searchTimer) clearTimeout(searchTimer);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "triggerRef",
        ref: triggerRef,
        class: "product-picker"
      }, [__props.showLabel ? (_openBlock(), _createElementBlock("label", _hoisted_1, [...(_cache[3] || (_cache[3] = [_createTextVNode(" 产品 ", -1), _createElementVNode("span", {
        class: "text-red-500"
      }, "*", -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["picker-trigger form-select flex items-center cursor-pointer", {
          'is-open': open.value,
          'form-control-sm': __props.compact
        }]),
        onClick: toggle
      }, [displayText.value ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(displayText.value), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_3, "请选择产品")), __props.clearable && __props.modelValue ? (_openBlock(), _createElementBlock("svg", {
        key: 2,
        class: "w-4 h-4 text-slate-400 hover:text-slate-600 flex-shrink-0 mr-1",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
        onClick: _withModifiers(clearSelection, ["stop"])
      }, [...(_cache[4] || (_cache[4] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M6 18L18 6M6 6l12 12"
      }, null, -1)]))])) : _createCommentVNode("", true), (_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["w-4 h-4 text-slate-400 transition-transform duration-200 flex-shrink-0", {
          'rotate-180': open.value
        }]),
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [...(_cache[5] || (_cache[5] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M19 9l-7 7-7-7"
      }, null, -1)]))], 2))], 2), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [open.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed inset-0 z-[9999]",
        onClick: close
      }, [_createElementVNode("div", {
        class: "picker-panel absolute bg-white rounded-xl shadow-2xl border border-slate-200 overflow-hidden",
        style: _normalizeStyle(panelStyle.value),
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "px-4 py-3 text-xs font-semibold text-slate-500 uppercase tracking-wider border-b border-slate-200 flex items-center min-h-[60px]"
      }, " 产品分类 ", -1)), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: _normalizeClass(["category-item px-3 py-2.5 text-sm cursor-pointer transition-colors border-l-2", selectedCategoryId.value === null ? 'border-primary-500 bg-primary-50 text-primary-700 font-medium' : 'border-transparent text-slate-700 hover:bg-slate-100']),
        onClick: _cache[0] || (_cache[0] = $event => selectCategory(null))
      }, [...(_cache[6] || (_cache[6] = [_createElementVNode("div", {
        class: "flex items-center gap-2"
      }, [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M4 6h16M4 10h16M4 14h16M4 18h16"
      })]), _createElementVNode("span", null, "全部产品")], -1)]))], 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categories, cat => {
        return _openBlock(), _createElementBlock("div", {
          key: cat.id,
          class: _normalizeClass(["category-item px-3 py-2.5 text-sm cursor-pointer transition-colors border-l-2", selectedCategoryId.value === cat.id ? 'border-primary-500 bg-primary-50 text-primary-700 font-medium' : 'border-transparent text-slate-700 hover:bg-slate-100']),
          onClick: $event => selectCategory(cat.id)
        }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [cat.icon && !isSvgPath(cat.icon) ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: resolveFileUrl(cat.icon),
          class: "w-4 h-4 object-cover rounded",
          alt: ""
        }, null, 8, _hoisted_10)) : (_openBlock(), _createElementBlock("svg", _hoisted_11, [_createElementVNode("path", {
          d: cat.icon && isSvgPath(cat.icon) ? cat.icon : 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_12)]))]), _createElementVNode("span", _hoisted_13, _toDisplayString(cat.name), 1)])], 10, _hoisted_7);
      }), 128))])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[8] || (_cache[8] = _createElementVNode("svg", {
        class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      })], -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchKeyword.value = $event),
        type: "text",
        placeholder: "搜索产品名称或编码",
        class: "form-search-input form-control-sm w-full",
        onInput: onSearchInput,
        onKeyup: _withKeys(onSearchInput, ["enter"])
      }, null, 544), [[_vModelText, searchKeyword.value]])]), __props.allowCreate ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "flex-shrink-0 px-2.5 py-1.5 text-xs bg-primary-50 text-primary-700 rounded-lg hover:bg-primary-100 transition-colors inline-flex items-center gap-1",
        onClick: handleAddTempProduct
      }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
        class: "w-3.5 h-3.5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 4v16m8-8H4"
      })], -1), _createTextVNode(" 新建 ", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_17, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[10] || (_cache[10] = [_createElementVNode("div", {
        class: "flex items-center gap-2 text-sm text-slate-500"
      }, [_createElementVNode("svg", {
        class: "w-4 h-4 animate-spin",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        class: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "4"
      }), _createElementVNode("path", {
        class: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      })]), _createTextVNode(" 加载中... ")], -1)]))])) : products.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("p", _hoisted_20, " 未找到「" + _toDisplayString(searchKeyword.value || '相关产品') + "」 ", 1), __props.allowCreate && searchKeyword.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "px-3 py-1.5 bg-primary-50 text-primary-700 rounded-lg text-sm hover:bg-primary-100 transition-colors inline-flex items-center gap-1.5",
        onClick: handleAddTempProduct
      }, [_cache[11] || (_cache[11] = _createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 4v16m8-8H4"
      })], -1)), _createTextVNode(" 创建产品「" + _toDisplayString(searchKeyword.value) + "」 ", 1)])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, p => {
        return _openBlock(), _createElementBlock("div", {
          key: p.id,
          class: _normalizeClass(["product-item px-4 py-3 cursor-pointer transition-colors hover:bg-primary-50", __props.modelValue === p.id ? 'bg-primary-50 border-l-2 border-l-primary-500' : '']),
          onClick: $event => selectProduct(p)
        }, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(p.name), 1), _createElementVNode("div", _hoisted_26, _toDisplayString(p.code), 1)]), __props.modelValue === p.id ? (_openBlock(), _createElementBlock("svg", _hoisted_27, [...(_cache[12] || (_cache[12] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5 13l4 4L19 7"
        }, null, -1)]))])) : _createCommentVNode("", true)])], 10, _hoisted_22);
      }), 128))]))]), selectedProduct.value ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_cache[13] || (_cache[13] = _createTextVNode(" 已选：", -1)), _createElementVNode("span", _hoisted_29, _toDisplayString(displayText.value), 1)])) : _createCommentVNode("", true)])])], 4)])) : _createCommentVNode("", true)]))], 512);
    };
  }
};